<div fxLayout="column">
  <div *ngIf="label.length > 0" class="input-label">{{ label }}</div>
  <mat-radio-group [formControl]="formCtrl">
    <div [fxLayout]="layout">
      <mat-radio-button
        (click)="getSelectedValue(element.value)"
        *ngFor="let element of elements"
        [value]="element.value"
        [disabled]="disabled"
        [class.danger]="element.color === 'danger'"
        >{{ element.label }}</mat-radio-button
      >
    </div>
  </mat-radio-group>
  <div class="input-hint-message" *ngIf="hintMessage.length > 0">{{ hintMessage }}</div>
</div>
